<template>
  <div>
    <v-progress-linear v-if="loading" indeterminate></v-progress-linear>
    <v-timeline align-left dense>
      <v-timeline-item v-for="log in logs" :color="logColor(log.action)" :key="log.id" right small>
        <v-alert :color="logColor(log.action)" class="ma-0 pa-1" outlined>
          <div class="text-center" v-if="log.location">
            {{log.location ? log.location.replace("https://wa.conan.conflabs.com", '') : 'N/A'}}
            <!--          <Confirm v-if="$store.state.user.email === 'devin@conflabs.com'" @confirm="delLog(log.id)">-->
            <!--            <template v-slot:activator="{on}">-->
            <!--              <v-btn v-on="on">delete</v-btn>-->
            <!--            </template>-->
            <!--          </Confirm>-->
          </div>
          <v-simple-table dense>
            <tbody>
            <tr>
              <td class="text-center">{{ $moment.utc(log.timestamp).local().fromNow() }}</td>
              <td class="text-center">{{log.action}}</td>
              <td class="text-center">{{log.model}}</td>
              <td class="text-center">{{log.display_text}}</td>
            </tr>
            </tbody>
          </v-simple-table>
          <v-divider></v-divider>
          <v-simple-table dense>
            <tbody>
            <template v-if="log.action === 'UPDATED'">
              <tr v-for="(diff, index) in log.diff" :key="index">
                <td class="text-right" style="width:1%">{{diff.key}}:</td>
                <td class="text-left" >
                  <LogDiff :diff="diff" is_update></LogDiff>
                  <!--                {{shorten(diff.from_display_text ? diff.from_display_text : diff.from_value)}} =>-->
                  <!--                <span style="white-space:nowrap">-->
                  <!--                 {{shorten(diff.display_text ? diff.display_text : diff.value)}}-->
                  <!--                </span>-->
                </td>
              </tr>
            </template>
            <template v-else-if="log.action === 'RELEASE' || (log.is_custom && typeof log.diff === 'object' && log.diff.display_text)">
              <tr>
                <td colspan="2">{{log.diff.display_text}}</td>
              </tr>
            </template>
            <template v-else>
              <tr v-for="(diff, index) in log.diff" :key="index">
                <td class="text-right" style="width:1%">{{diff.key}}:</td>
                <td class="text-left" style="white-space:nowrap">
                  <LogDiff :diff="diff"></LogDiff>
                  <!--                {{diff.display_text ? diff.display_text : diff.value}}-->
                </td>
              </tr>
            </template>
            </tbody>
          </v-simple-table>
          <v-divider></v-divider>
          <div class="text-center">{{log.user_name}} - {{$moment.utc(log.timestamp).local().format("YYYY-MM-DD h:mm:ssa")}}</div>

        </v-alert>
      </v-timeline-item>
    </v-timeline>
  </div>
</template>

<script>
import log from "@/components/logs/V2/Log";

export default {
  name: "LogList",
  components: {
    LogDiff: () => import('./LogDiff')
  },
  data: () => ({
    logs: [],
    loading: false,
  }),
  props: {
    logs_snapshot: {
      required: false,
      default: false,
    },
    query_uuid:{
      required: false,
      type: [String,Boolean,Array],
    },
    query_uuid_keys: {
      required: false,
      type: [Array,Boolean],
    }
  },
  mounted(){
    if(this.query_uuid) {
      this.runQueries();
    }
    if(this.logs_snapshot){
      //console.log('logSnaps')
      this.mapCustomLogs()
    }
  },
  methods: {
    async delLog(id){
      await this.$firestore.collection('conan_logs').doc(id).delete();
      let index = this.logs.findIndex(log => log.id === id);
      this.logs.splice(index, 1)
    },
    async mapCustomLogs(){
      let logSets = [this.mapDocuments(this.logs_snapshot)];
      for(let logSet of logSets){
        this.logs = this.logs.concat(logSet);
      }
      this.logs = this.logs.filter(log => typeof log.diff === 'object' || log.diff.length > 0);
      this.logs = this.logs.sort((a,b) =>  this.$moment.utc(b.timestamp).unix() - this.$moment.utc(a.timestamp).unix())
    },
    async runQueries(){
      this.loading = true;
      // let mainSet = await this.$firestore.collection('conan_logs').where('uuid', '==', this.query_uuid).get();
      let logSets = [

      ];
      if(typeof this.query_uuid === 'string'){
        let logSet = await this.$firestore.collection('conan_logs').where('uuid', '==', this.query_uuid).get();
        logSets.push(this.mapDocuments(logSet))
      }else if(Array.isArray(this.query_uuid)){
        for(let uuid of this.query_uuid){
          let logSet = await this.$firestore.collection('conan_logs').where('uuid', '==', uuid).get();
          logSets.push(this.mapDocuments(logSet))
        }
      }
      console.log(logSets, "LOG SETS");
      if(this.query_uuid_keys){
        for(let key  of this.query_uuid_keys){
          let logSet = await this.$firestore.collection('conan_logs').where(key, '==', this.query_uuid).get();
          logSets.push(this.mapDocuments(logSet))
        }
      }
      for(let logSet of logSets){
        this.logs = this.logs.concat(logSet);
      }
      this.logs = this.logs.filter(log => typeof log.diff === 'object' || log.diff.length > 0);
      this.logs = this.logs.sort((a,b) =>  this.$moment.utc(b.timestamp).unix() - this.$moment.utc(a.timestamp).unix())
      this.loading = false;
    },
    mapDocuments(snapshot){
      return snapshot.docs.map(doc => ({id: doc.id, ...doc.data()}))
    },
    logColor(action, is_custom = false){
      if(action === "CREATED"){
        return "success"
      }
      if(action === "UPDATED"){
        return "orange darken-3"
      }
      if(action === "DELETED"){
        return "error"
      }
      if(action === "RESTORED"){
        return "secondary"
      }
      if(action === "RELEASE" || is_custom){
        return "primary"
      }

      return ''
    },
  }
}
</script>

<style scoped>

</style>
